<template>
  <div>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 class="h2">Survey Sections</h1>
      </div>

      <div class="card-deck mb-3 text-center">

        <quiz-card-bootstrap
          v-for="quiz in quizes"
          :key="quiz.id"
          :title="quiz.title | translategrader($i18n.locale)"
          :color="quiz.color"
          :description="quiz.description | translategrader($i18n.locale)"
          :id="quiz.id"
        ></quiz-card-bootstrap>

        <div class="card mb-4 shadow-sm border-info" style="max-width: 250px; min-width: 250px;">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal text-info">Nouvelle section</h4>
          </div>
          <div class="card-body">
            <p class=" mt-3 mb-4 text-info">
              Cliquer ici pour ajouter une nouvelle section ...
            </p>
            <router-link tag="button" class="btn btn-lg btn-block btn-outline-info" :to="{ name: 'Create Survey' }">Ajouter</router-link>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  import { RESET_QUIZ } from '@/store/quiz/mutations';

  import QuizCard from '@/components/quiz/QuizCard';
  import QuizCardBootstrap from '@/components/quiz/QuizCardBootstrap';

  export default {
    name: 'dashboard',

    components: {
      QuizCard,
      QuizCardBootstrap
    },

    created() {
      this.findQuizes();
      this.resetNewQuiz();
    },


    computed: {
      ...mapGetters('user', {
        loggedIn: 'loggedIn',
        profile: 'profile',
      }),

      ...mapGetters('quiz', {
        quizes: 'list'
      })
    },

    methods: {
      ...mapActions({
        findQuizes: 'quiz/list'
      }),

      ...mapMutations('quiz', {
        resetNewQuiz: RESET_QUIZ
      }),
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/AdminPage.vue